import { createContext } from 'react';
import { UnitLocationStore } from './unit-location-store';

export const UnitLocationStoreContext = createContext<UnitLocationStore | undefined>(undefined);
